import React from 'react';
import PropTypes from 'prop-types';

/**
 * Displays route deviation score
 * @param {Object} props
 * @param {number} props.deviationScore - Deviation score (0-100)
 */
const RouteInfoDeviation = ({ deviationScore }) => {
  if (deviationScore === undefined || deviationScore === null) {
    return null;
  }

  const getScoreColor = (score) => {
    if (score >= 80) return '#4CAF50'; // Green - Excellent
    if (score >= 60) return '#8BC34A'; // Light Green - Good
    if (score >= 40) return '#FFC107'; // Yellow - Fair
    if (score >= 20) return '#FF9800'; // Orange - Poor
    return '#F44336'; // Red - Very Poor
  };

  const getScoreLabel = (score) => {
    if (score >= 80) return 'Excellent';
    if (score >= 60) return 'Good';
    if (score >= 40) return 'Fair';
    if (score >= 20) return 'Poor';
    return 'Very Poor';
  };

  const scoreColor = getScoreColor(deviationScore);
  const scoreLabel = getScoreLabel(deviationScore);

  return (
    <div className="route-info-section">
      <h3 className="section-title">Route Adherence</h3>
      <div className="deviation-display">
        <div className="deviation-score" style={{ color: scoreColor }}>
          {deviationScore.toFixed(1)}
        </div>
        <div className="deviation-label" style={{ color: scoreColor }}>
          {scoreLabel}
        </div>
        <div className="deviation-bar-container">
          <div 
            className="deviation-bar-fill" 
            style={{ 
              width: `${deviationScore}%`,
              backgroundColor: scoreColor
            }}
          />
        </div>
        <div className="deviation-description">
          Compliance with SOP route
        </div>
      </div>
    </div>
  );
};

RouteInfoDeviation.propTypes = {
  deviationScore: PropTypes.number,
};

export default RouteInfoDeviation;